import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ReCaptchaProvider } from "@wss/re-captcha";
import { ExpandedDescriptionTextSectionTypes, ProductDetailPageResult, Templates } from "../ProductDetailPageResult";
import Certifications from "../Certifications";
import ExpandedContentSection from "./ExpandedDescriptionTemplateDetailSection/ExpandedContentSection";
import FeaturedProductReview from "./ExpandedDescriptionTemplateDetailSection/FeaturedProductReview";
import HeadlineAndContent from "./ExpandedDescriptionTemplateDetailSection/HeadlineAndContent";
import ProductNoticesAndWarnings from "../ProductNoticesAndWarnings";
import QuestionsAndAnswers from "../QuestionsAndAnswers/QuestionsAndAnswers";
import SpecificationSummary from "./ExpandedDescriptionTemplateDetailSection/SpecificationSummary";
import useIsMounted from "~/common/useIsMounted";
import VideoSpotlight from "./ExpandedDescriptionTemplateDetailSection/VideoSpotlight";
import Compare from "../Compare";
import { User } from "~/common/Store/models/User";
import { RootState } from "~/common/Store/models/RootReadonly";
import { getLowestPriceWithQuantityDiscounts } from "../Pricing/getLowestPrice";
import Warnings from "../Warnings";
import ChatbotQuestionsAndAnswers from "../QuestionsAndAnswers/ChatbotQuestionsAndAnswers";
interface ExpandedDescriptionTemplateDetailSectionProps {
  activeTemplate: ProductDetailPageResult;
  user: User;
  mounted: boolean;
}
const ExpandedDescriptionTemplateDetailSection = ({
  activeTemplate,
  user
}: ExpandedDescriptionTemplateDetailSectionProps) => {
  const {
    expandedDescription,
    certifications,
    questionsAndAnswers,
    itemNumber,
    productDisclaimer,
    isCommonCarrier,
    noticesAndWarnings,
    template,
    videos,
    showEverlivingProductPage,
    itemNumberId
  } = activeTemplate;
  const isEverlivingOrOutlet = template === Templates.OutletTemplate || showEverlivingProductPage;
  const mounted = useIsMounted();
  const videosToSpotlight = videos?.length ? videos.filter(video => !video.isModelingVideo) : [];
  const [displayPrice, setdisplayPrice] = useState(getLowestPriceWithQuantityDiscounts(activeTemplate, user));
  useEffect(() => {
    setdisplayPrice(getLowestPriceWithQuantityDiscounts(activeTemplate, user));
  }, [activeTemplate, displayPrice, user, user.index]);
  const introductionSection = expandedDescription && expandedDescription.sections && expandedDescription.sections.find(x => x.type === ExpandedDescriptionTextSectionTypes.Introduction);
  const specificationSummary = expandedDescription && expandedDescription.specificationSummary;
  return <div className="box clearfix" id="details" data-testid="expanded-description-detail" data-sentry-component="ExpandedDescriptionTemplateDetailSection" data-sentry-source-file="ExpandedDescriptionTemplateDetailSection.tsx">
      <div className="details flow">
        <div id="details-group" style={{
        scrollMarginTop: "100px"
      }}>
          {introductionSection && <HeadlineAndContent header={introductionSection?.headline} description={introductionSection?.body} image={introductionSection?.image} imageHasPadding={introductionSection?.imageHasPadding} video={introductionSection?.video} loops={introductionSection?.isVideoRepeating ? undefined : 1} />}
          <div className="detail-section feature-review certs">
            {certifications && certifications?.length > 0 && <Certifications certifications={certifications} isExpandedDescriptionTemplate data-testid="expanded-certifications" />}
            {expandedDescription.featuredReview && <FeaturedProductReview review={expandedDescription.featuredReview} />}
          </div>
          {expandedDescription.sectionsGrouping && <ExpandedContentSection sectionsGrouping={expandedDescription.sectionsGrouping} price={displayPrice} />}
        </div>
      </div>
      {itemNumberId > 0 && !isEverlivingOrOutlet && <div id="customerQA" className="border-y-[1px] border-solid border-[#DBDFD8] border-x-0 scroll-mt-[100px]" tabIndex={-1}>
          <ReCaptchaProvider>
            <ChatbotQuestionsAndAnswers itemNumberId={itemNumberId} itemNumber={itemNumber} isExpandedDescriptionTemplate />
          </ReCaptchaProvider>
          {questionsAndAnswers?.length > 0 && <QuestionsAndAnswers questionsAndAnswers={questionsAndAnswers} isExpandedDescriptionTemplate />}
        </div>}
      {mounted && !!videosToSpotlight?.length && <VideoSpotlight videos={videosToSpotlight} autoPlayOnVideoSwap />}
      {expandedDescription?.compareProducts && <Compare key={`expandedTemplateCompare-${itemNumber}`} user={user} product={activeTemplate} />}
      {specificationSummary && specificationSummary.length > 0 && <SpecificationSummary specificationSummary={expandedDescription.specificationSummary} />}
      <div className="detail-section warranty-template">
        <ProductNoticesAndWarnings isCommonCarrier={isCommonCarrier} noticesAndWarnings={noticesAndWarnings} showEverlivingProductPage={showEverlivingProductPage} data-sentry-element="ProductNoticesAndWarnings" data-sentry-source-file="ExpandedDescriptionTemplateDetailSection.tsx" />
        <Warnings prop65Warning={productDisclaimer?.prop65Warning} displayAb1200Disclaimer={productDisclaimer?.displayAb1200Disclaimer} ab1200Chemicals={productDisclaimer?.ab1200Chemicals} spanishAb1200Chemicals={productDisclaimer?.spanishAb1200Chemicals} data-sentry-element="Warnings" data-sentry-source-file="ExpandedDescriptionTemplateDetailSection.tsx" />
      </div>
    </div>;
};
export const mapStateToProps = (state: RootState, ownProps: ExpandedDescriptionTemplateDetailSectionProps) => {
  if (!ownProps.mounted) return {
    user: ownProps.user
  };
  return {
    user: state.user
  };
};
export default connect(mapStateToProps)(ExpandedDescriptionTemplateDetailSection);